'use client';

import { createContext, useContext } from 'react';

export type FieldContextValue = {
    error?: string | boolean;
    id: string;
    name?: string;
    required?: boolean;
};

export const FieldContext = createContext<FieldContextValue | null>(null);

export function useField() {
    const context = useContext(FieldContext);

    if (!context) {
        throw new Error('useField must be used within a Field');
    }

    return context;
}
